import { create } from "apisauce";
import Utils from "../Utils";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const tamarackAPI = create({ baseURL: BASE_URL });

tamarackAPI.setHeader("requestor", "Redesign");

tamarackAPI.axiosInstance.interceptors.request.use(async (config) => {
	config.headers.email=window?.authProvider?.account?.userName
	if (window.access_token) {
		// console.log("Found access token");
		config.headers.Authorization = `Bearer ${window.access_token}`;
	} else if (window.id_token) {
		// console.log("Found id token");
		config.headers.Authorization = `Bearer ${window.id_token}`;
	} else if (window.authProvider) {
		// console.log("Trying to get access token using provider");
		const token = await window.authProvider.getAccessToken();
		// console.log(token.accessToken);
		config.headers.Authorization = `Bearer ${token.accessToken}`;
	}

	return config;
});


export { tamarackAPI };

export const processApiResponse = (response, method, uri) => {
	return new Promise((resolve, reject) => {
		if (response.status === 404 && response.data.statusCode === 404) {
			resolve([]);
		}
		if (response.status >= 200 && response.status < 400) {
			Utils.isJsonString(response.data)
				? resolve(JSON.parse(response.data))
				: resolve(response.data);
		} else if (method === "get" && response.status === 404) {
			resolve([]);
		} else if (response.status === 401) {
			reject({ message: "You are unauthenticated, please log in again" });
		} else {
			console.error(
				`HTTP ${method} call to ${uri} failed with response code ${response.status}`
			);
			reject({ message: response.data?.Message || response?.data?.statusMessage });
		}
	});
};

// application api response for special case like done, start work application.
export const processApplicationApiResponse = (response, method) => {
	return new Promise((resolve, reject) => {
		if (response.status >= 200 && response.status < 400) {
			Utils.isJsonString(response.data)
				? resolve(JSON.parse(response.data))
				: resolve(response.data);
		} else if (method === "get" && response.status === 404) {
			resolve([]);
		} else if (response.status === 401) {
			reject({ message: "You are unauthenticated, please log in again" });
		} else {
			reject({ message: response.data?.StatusMessage || response.data?.Message || response?.data?.statusMessage });
		}
	});
};


export const processApiCustomResponse = (response, method, uri) => {
	return new Promise((resolve, reject) => {
		if (response.status === 400 && response.data.statusCode === 404) {
			reject({ message: `HTTP ${method} call to ${uri} failed with response code ${response.status}` });
		}
		if (response.status >= 200 && response.status < 400) {
			Utils.isJsonString(response.data)
				? resolve(JSON.parse(response.data))
				: resolve(response.data);
		} else if (method === "get" && response.status === 404) {
			resolve([]);
		} else if (response.status === 401) {
			reject({ message: "You are unauthenticated, please log in again" });
		} else {
			console.error(
				`HTTP ${method} call to ${uri} failed with response code ${response.status}`
			);
			reject({ message: response.data?.Message || response?.data?.statusMessage });
		}
	});
};